var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 3.00004C7.36835 3.00004 7.66683 3.29852 7.66683 3.66671V7.66671C7.66683 8.0349 7.36835 8.33337 7.00016 8.33337C6.63197 8.33337 6.3335 8.0349 6.3335 7.66671V3.66671C6.3335 3.29852 6.63197 3.00004 7.00016 3.00004Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 9.66671C6.63197 9.66671 6.3335 9.96519 6.3335 10.3334C6.3335 10.7016 6.63197 11 7.00016 11C7.36835 11 7.66683 10.7016 7.66683 10.3334C7.66683 9.96519 7.36835 9.66671 7.00016 9.66671Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00016 0.333374C3.31826 0.333374 0.333496 3.31814 0.333496 7.00004C0.333496 10.6819 3.31826 13.6667 7.00016 13.6667C10.6821 13.6667 13.6668 10.6819 13.6668 7.00004C13.6668 3.31814 10.6821 0.333374 7.00016 0.333374ZM1.66683 7.00004C1.66683 9.94556 4.05464 12.3334 7.00016 12.3334C9.94568 12.3334 12.3335 9.94556 12.3335 7.00004C12.3335 4.05452 9.94568 1.66671 7.00016 1.66671C4.05464 1.66671 1.66683 4.05452 1.66683 7.00004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.6a3ce8e878d63b511b8be231453fcc8b.svg";
export { ForwardRef as ReactComponent };